<template>
  <v-container grid-list-md style="padding: 16px 24px 10px 24px;">
    <v-row>
      <v-col cols="12">
        <span class="headline font-weight-light">Upute za korištenje SUMIT matice</span>
      </v-col>
    </v-row>
    <v-row class="mt-5">
      <v-col cols="12" md="4" >
        <div class="videoteka">
          <template v-for="(item, i) in items">
            <v-card :key="i" flat outlined style="width: 97%;" :class=" i !== 0 ? 'mt-4': ''"
                    @click="changeVideo(item.link)">
              <v-row align="center" justify="center">
                <v-col cols="9">
                  <div class="pl-4 text-h6" style="color: #084776">
                    {{ item.title }}
                  </div>
                  <v-card-subtitle>Prikaži</v-card-subtitle>
                </v-col>
                <v-col cols="3">
                  <v-card-text>
                    <v-icon :color="selectedVideo === item.link ? 'red' : '#084776'">fas fa-play</v-icon>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-card>
          </template>
        </div>
      </v-col>
      <v-col cols="12" md="8">
        <div class="w-100 group" style="width: 100%; height: 100%; position: relative;">
<!--          <div id="poster-image" @click="fadeImage"-->
<!--               :style="{ background: 'url(' + require('@/assets/img/poster.jpeg') + ')' + 'center center' }"></div>-->
<!--          <iframe id="video-iframe" class="sumtv-iframe"-->
<!--                  :src="selectedVideo"-->
<!--                  frameborder="0" scrolling="no" seamless="" allowfullscreen="allowfullscreen">-->
<!--          </iframe>-->
          <video class="sumtv-iframe" controls :poster="require('@/assets/img/poster.jpeg')">
            <source :src="selectedVideo" type="video/mp4">
<!--            <source src="movie.ogg" type="video/ogg">-->
            Vaš preglednik ne podržava video.
          </video>
          <div style="width: 80px; height: 80px; position: absolute; opacity: 0; right: 0px; top: 0px;"></div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Instructions",
  data: () => ({
    selectedVideo: '',
    items: [
      {
        title: 'Kreiranje odjela',
        link: 'https://api-skole.sum.ba/v2/files/1.mp4'
      },
      // {
      //   title: 'Kreiranje nastavnih planova',
      //   link: 'https://drive.google.com/file/d/191ZLutwYvVIYkzC3zLvvsTgiKPKzZkPH/preview'
      // },
      // {
      //   title: 'Ažuriranje smjerova',
      //   link: 'https://drive.google.com/file/d/10AeaDkAawTI8A7BytR85egUu5SNuWuUH/preview'
      // }
    ]
  }),
  created() {
    this.selectedVideo = this.items[0].link
  },
  methods: {
    fadeImage() {
      document.getElementById("poster-image").style.opacity = "0";
      document.getElementById("poster-image").style.zIndex = "1";
      document.getElementById("video-iframe").style.zIndex = "999";
    },
    changeVideo(val){
      this.selectedVideo = val
      document.getElementById("poster-image").style.opacity = "1";
    }
  }
}
</script>

<style scoped>
.sumtv-iframe {
  width: 100%;
  height: 100%;
}

.videoteka {
  max-height: 64.5vh;
  overflow-y: scroll;
  width: 100% !important;
  overflow-x: hidden;
}

#poster-image {
  /*background: `url(${require("@/assets/img/poster.jpg")}) center center`;*/
  background-size: cover;
  bottom: 0;
  left: 0;
  opacity: 1.0;
  position: absolute;
  /*z-index: 10;*/
  height: 100%;
  width: 100%;
  transition: all 0.3s ease-in;
  cursor: pointer;
}

</style>